import React, { useEffect } from "react";
import { useToken } from "@bn/api";
import { LoadingProgressBar } from "@components";
import { USE_INTERNAL_AUTH } from "@helpers";
import { useMandatorLinks } from "@hooks";

export const LogoutWithRedirect = () => {
  const { logout } = useToken({ enabled: false });
  const { logoutRedirectUrl } = useMandatorLinks();

  useEffect(() => {
    logout();

    const externalRedirectUrl = USE_INTERNAL_AUTH
      ? undefined
      : logoutRedirectUrl;
    window.location.href =
      externalRedirectUrl ?? import.meta.env.VITE_APP_ROOT_URL!;
  }, [logout, logoutRedirectUrl]);

  return <LoadingProgressBar />;
};
